import { LABELS_API_PATH } from "src/constants/constants";
import { createUrl } from "./utils";
import { Brand } from "./types";

export class HttpHandler {
  static async getLabels(countryCode: string, languageCode: string) {
    const labelsAPI = createUrl({
      endpoint: LABELS_API_PATH,
      queryParams: {
        'country-code': countryCode,
        'language-code': languageCode,
        'brand': Brand.SE_BRAND,
      }
    });
    try {
      const response = await fetch(labelsAPI);
      const labels = await response.json();
      return { labels, error: null };
    } catch(error) {
      return { labels: null, error }
    }
  }
}